export default function PhoneString(phone) {
  return `${phone.substr(0,4)} ${phone.substr(4,5)}-${phone.substr(-4)}`;
}
